.automated-email-cards > :first-child {
    margin-top: -9px;
}
